var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 2H11V1.0625C11 0.757812 10.7422 0.5 10.4375 0.5H4.0625C3.73438 0.5 3.5 0.757812 3.5 1.0625V2H1.0625C0.734375 2 0.5 2.25781 0.5 2.5625V3.875C0.5 4.71875 1.01562 5.58594 1.92969 6.24219C2.67969 6.78125 3.57031 7.10938 4.50781 7.22656C5.25781 8.44531 6.125 8.9375 6.125 8.9375V10.625H5C4.15625 10.625 3.5 11.1172 3.5 11.9375V12.2188C3.5 12.3828 3.61719 12.5 3.78125 12.5H10.7188C10.8594 12.5 11 12.3828 11 12.2188V11.9375C11 11.1172 10.3203 10.625 9.5 10.625H8.375V8.9375C8.375 8.9375 9.21875 8.44531 9.96875 7.22656C10.9062 7.10938 11.7969 6.78125 12.5469 6.24219C13.4609 5.58594 14 4.71875 14 3.875V2.5625C14 2.25781 13.7422 2 13.4375 2ZM2.82031 5.02344C2.23438 4.625 2 4.15625 2 3.875V3.5H3.5C3.52344 4.27344 3.64062 4.95312 3.80469 5.53906C3.42969 5.39844 3.10156 5.23438 2.82031 5.02344ZM12.5 3.875C12.5 4.27344 12.0781 4.74219 11.6562 5.02344C11.375 5.23438 11.0469 5.39844 10.6719 5.53906C10.8359 4.95312 10.9531 4.27344 10.9766 3.5H12.5V3.875Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.7ee45d0d.svg";
export { ForwardRef as ReactComponent };